/** @format */
import Master from '../Layouts/Master';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import moment from 'jalali-moment';

import { EventContext } from '../../Contexts/EventContext';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { countOfRecourd } from '../../Shared/utils/helper';

const Fandom = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [formRemoveId, setFormRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    getFamdom();
  }, [search]);
  const getFamdom = async () => {
    setLoading(true);
    await useApi.get(
      `/fandom${search}`,
      {},
      (res) => {
        eventContext.fandoms = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeForm = async (famdomId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/fandom/${famdomId}`,
      {},
      (res) => {
        success('تیم مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getFamdom();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست تیم ها
          </h1>
        </div>
        <Link
          to='/panel/fandom/create'
          className='d-flex flex-row btn btn-outline-info '
        >
          <i className='fad fa-plus f-16 mx-2'></i>
          <span className='f-13'>ایجاد تیم</span>
        </Link>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.fandoms?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>نام تیم</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.fandoms?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {countOfRecourd(
                      index,
                      eventContext.fandoms?.meta?.pagination?.per_page,
                      eventContext.fandoms?.meta?.pagination?.current_page,
                    )}
                  </th>
                  <td>{item.title}</td>

                  <td>
                    <span
                      className={`badge badge-${
                        item.status === 0 ? 'danger' : 'success'
                      } badge-pill p-2`}
                    >
                      {item.status === 0 ? 'غیرفعال' : 'فعال'}
                    </span>
                  </td>
                  <td>
                    <div className='d-flex flex-row'>
                      <Link
                        to={`/panel/fandom/edit/${item.id}`}
                        className='mx-2'
                      >
                        ویرایش
                      </Link>
                      <Link
                        className='mx-2'
                        to='#'
                        onClick={(e) => {
                          e.preventDefault();
                          setFormRemoveId(item.id);
                          setModalIsOpen(true);
                        }}
                      >
                        حذف
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد تیم بر روی منوی ایجاد تیم کلیک کنید
            </span>
          </div>
        )}
      </div>

      <div className='w-100 mt-4 d-flex'>
        <Pagination
          search={search}
          totalPage={eventContext.fandoms?.meta?.pagination?.total_pages}
          basePath={`/panel/fandom`}
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف فرم مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeForm(formRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Fandom;
